export const zIndex = {
  graphModal: 4100,
  navigationContainer: 3100,
  navSide: 3100,
  floatingMenu: 3100,
  footer: 3099,
  navSideShadow: 2100,
  loading: 2100,
  dropZone: 2100,
  graphTooltip: 1099,
  functionCardSlideIcon: 99,
  graphNavigator: -1,
  wordCloud: -1,
};
